import { render } from "./BlogPostList.vue?vue&type=template&id=a8b4262a&scoped=true"
import script from "./BlogPostList.vue?vue&type=script&lang=js"
export * from "./BlogPostList.vue?vue&type=script&lang=js"

import "./BlogPostList.vue?vue&type=style&index=0&id=a8b4262a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8b4262a"]])

export default __exports__